import axiosInstance from './axiosInstance';

const IncomeExpenditureService = {
  // Income endpoints
  getIncomeItems: () => axiosInstance.get('/api/financial-reports/', { params: { tag: 'Income' } }),
  createIncomeItem: (data) => axiosInstance.post('/api/financial-reports/', { ...data, tag: 'Income' }),
  updateIncomeItem: (id, data) => axiosInstance.put(`/api/financial-reports/${id}/`, { ...data, tag: 'Income' }),
  deleteIncomeItem: (id) => axiosInstance.delete(`/api/financial-reports/${id}/`),

  // Expenditure endpoints
  getExpenditureItems: () => axiosInstance.get('/api/financial-reports/', { params: { tag: 'Expense' } }),
  createExpenditureItem: (data) => axiosInstance.post('/api/financial-reports/', { ...data, tag: 'Expense' }),
  updateExpenditureItem: (id, data) => axiosInstance.put(`/api/financial-reports/${id}/`, { ...data, tag: 'Expense' }),
  deleteExpenditureItem: (id) => axiosInstance.delete(`/api/financial-reports/${id}/`),
};

export default IncomeExpenditureService;
